import React from 'react';

// host component id
export const PortalContext = React.createContext('style-tag');
